export const event = {
  eventLogo: 'https://cdn.magicpatterns.com/uploads/wkApFctTadTHV7J6KFurW4/Logo_Light_background_copy.jpg',
  organizerLogo: 'https://cdn.magicpatterns.com/uploads/rxnFGMHjpCg2yfoTHsqiWe/Logo_Confederation_nationale_du_tourisme_Maroc_depuis_2022.jpg',
  formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfpkNyxQy2Fk56WErgl9sEY6oEdfwMUzCvSLX5fUfbiWww1bQ/viewform',
  // Leave empty to keep the live button locked. Paste the new live link here to unlock it at linkOpensAt.
  liveUrl: 'https://www.youtube.com/watch?v=DJszdJ1-O34',
  // Morocco time (GMT / UTC+0)
  // Link is open immediately (date in the past)
  linkOpensAt: '2026-01-01T00:00:00+00:00',
  broadcastStart: '2026-10-15T16:00:00+00:00',
  linkAvailability: 'Lien accessible jeu. 15 oct. à 15h00',
  broadcastLabel: 'Le live commence jeu. 15 oct. à 16h00'
};
